module.exports = __webpack_public_path__ + "static/media/wad2.97866b1b.svg";